import { TagTypes } from '~generated/types'

const tagNamesVariants = {
  [TagTypes.CHANNEL]: 'Channel tags',
  [TagTypes.TASK]: 'Task tags',
  [TagTypes.ASSET]: 'Asset tags',
  [TagTypes.COMPANY]: 'Battlecard tags',
  [TagTypes.PRODUCT_LINE]: 'Product line tags',
  [TagTypes.FEEDBACK_POST]: 'Product idea tags',
  [TagTypes.RELEASE_NOTE]: 'Release notes tags',
  [TagTypes.LAUNCH_NAME]: 'Launch name tags',
  [TagTypes.RESEARCH_HUB_INSIGHTS]: 'Research insights tags',
  [TagTypes.RESEARCH_HUB_TESTIMONIALS]: 'Research testimonials tags',
  [TagTypes.RESEARCH_HUB_PERSONAS]: 'Research personas tags',
  [TagTypes.ROADMAP_ITEM]: 'Roadmap item tags',
}
export default tagNamesVariants
